// react
import React from 'react';
import styled from 'styled-components';
import { css } from 'styled-components';

const months: { [key: number]: string } = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

/**
 * DateIcon is a container for displaying the month and the day.
 */
export const DateIcon = ({ date, size }: DateIconProps) => {
  return (
    <IconBody size={size}>
      <Month size={size}>{months[date.getMonth()]}</Month>
      <Day size={size}>{date.getDate()}</Day>
    </IconBody>
  );
};

interface IconBodyProps {
  size: 'sm' | 'md';
}

const IconBody = styled.div<IconBodyProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.size === 'sm' &&
    css`
      width: 36px;
      height: 36px;
    `}
  ${(props) =>
    props.size === 'md' &&
    css`
      width: 80px;
      height: 80px;
    `}


  background-color: ${(props) => props.theme.color.neutral[10]};
  border-radius: 4px;
  box-shadow: ${(props) => props.theme.elevation[3]};
  overflow: hidden;
  z-index: 1;
`;

interface MonthProps {
  size: 'sm' | 'md';
}

const Month = styled.div<MonthProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e00000;
  font: ${(props) =>
    props.size === 'sm'
      ? props.theme.typography.body.xxs.semibold
      : props.theme.typography.body.md.semibold};
  color: ${(props) => props.theme.color.neutral[10]};
  width: 100%;
  ${(props) =>
    props.size === 'sm' &&
    css`
      height: 16px;
    `}
  ${(props) =>
    props.size === 'md' &&
    css`
      height: 31px;
    `}
`;

interface DayProps {
  size: 'sm' | 'md';
}

const Day = styled.div<DayProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font: ${(props) => props.theme.typography.body.sm.semibold};
  color: ${(props) => props.theme.color.neutral[100]};
  width: 100%;
  ${(props) =>
    props.size === 'sm' &&
    css`
      height: 20px;
    `}
  ${(props) =>
    props.size === 'md' &&
    css`
      height: 49px;
    `}
  font: ${(props) =>
    props.size === 'sm'
      ? props.theme.typography.body.xxs.semibold
      : props.theme.typography.body.xxl.semibold};
`;

interface DateIconProps {
  date: Date;
  size: 'sm' | 'md';
}

DateIcon.displayName = 'DateIcon';

export default DateIcon;
